import React from 'react'
import './Notification.css'
import IosArrowForward from 'react-ionicons/lib/IosArrowForward'
import {Col, Row} from "react-bootstrap";
import history from "../../history";

class Notification extends React.Component {

   constructor(props) {
      super(props)

      this.state = {
         read: this.props.read,
         archived: this.props.archived
      }
   }

   render() {
      return (
          <Row className={"Notification pb-2" + (this.state.read ? "" : " unread")}>
             <Col xs={1} className={"pr-0"}>
                <div className={"input-container"}>
                   <input
                       type='checkbox'
                       value={this.props.id}
                       onChange={this.props.onChangeCheckBox}
                       checked={this.props.checkboxChecked}
                   />
                   {history.location.pathname === "/notifications" &&
                       <div className="unread-circle"/>
                   }
                </div>
             </Col>
             <Col xs={11} className={"notification-content border-bottom" + (history.location.pathname === "/notifications" ? " pl-0" : "")} onClick={this.props.onClick}>
                <div className={"pb-2"}>
                   <div className={"title-container"}>
                      <h5 className={"title"}>{this.props.title}</h5>
                      <div className={"date"}>
                         {this.props.date}
                         <IosArrowForward fontSize="25px" color="#bbbbbb"/>
                      </div>
                   </div>
                   <div className={"body"}>
                      <p>{this.props.body}</p>
                   </div>
                </div>
             </Col>
          </Row>
      )
   }

}

export default Notification